// extracted by mini-css-extract-plugin
export default {"ledgerTableWrapper":"sortableDataTable_ledgerTableWrapper__tP3iU","tableResponsive":"sortableDataTable_tableResponsive__5ndyT","customTable":"sortableDataTable_customTable__VJ++k"};